import { DrugEntity } from './drugEntity';
import { ChildId } from './valueObjects/childId';
import { DrugContent } from './valueObjects/drugContent';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type { DrugPropsPvt, DrugPropsPub } from './drugEntity';
import type { EntityPubNotNullType } from '@/domain/entityPub';
import type { DrugJson, DrugJsonPub, DrugJsonPvt } from '@/types/domain/drug/entities/drugEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * 薬ファクトリ
 */
export class DrugFactory extends FactoryPub<
  DrugEntity,
  DrugPropsPvt,
  DrugJsonPvt,
  DrugPropsPub,
  DrugJsonPub
> {
  /**
   * 比較する
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePub = (
    a: DrugJson,
    b: DrugJson,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: DrugPropsPvt,
    propsPub: EntityPubNotNullType<DrugPropsPub>,
  ): DrugEntity {
    return new DrugEntity(props, propsPub);
  }

  /**
   * 公開データからエンティティを生成する
   * @param json 公開データ
   * @returns 薬エンティティ
   */
  createFromEntityDataPub(json: DrugJson): DrugEntity {
    return new DrugEntity({
      parentId: ParentId.create(json.data.parentId),
      childId: ChildId.create(json.data.childId),
      measurerId: MeasurerId.create(json.data.measurerId),
      measurerType: MeasurerType.create(json.data.measurerType),
      measureDateTime: MeasureDateTime.create(new Date(json.data.measureDateTime)),
      drugContent: DrugContent.create(json.data.drugContent),
    }, {
      sendId: json.pub.sendId,
      replyId: json.pub.replyId,
      data: {},
    });
  }
}
